export default class Shortcut {
  id: number;
  name: string;

  constructor({ id, name }: any) {
    this.id = id;
    this.name = name;
  }
}
